import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../../../kvComponent/core/assets";

import {IntermediatePart} from "../intermediatePart";
import {Shower} from "./shower";
import Walls from "./walls";
import {getCurrentRoomType} from "../../../appLayout";
import {LOOK_ROOM_TYPES} from "../constants";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'parent_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.floor";
    this.partThumbnail = floorThumbnail;
    this.relatedGroupNames = ["Floor"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Flor":
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

}

class FloorBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathroom_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.floor";
    this.isStoneFeature = true;
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent ? showerParent.showerSize() : null;
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    const wallParent = layout.parts[Walls.id];
    if ((getCurrentRoomType(layout) === LOOK_ROOM_TYPES.as) && wallParent && wallParent.splitWall) {
      conditions.push({
        propName: "SplitWallType",
        propValue: wallParent.getSplitWallType()
      })
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Background.Floor;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}


